export class CodeDesignationCodeClient {
	code: string;
	codeClient: string;
	designation: string;

	constructor(code?: string, designation?: string, codeClient?: string) {
		this.code = code;
		this.designation = designation;
		this.codeClient = codeClient;
	}

	deserialize(input: any): CodeDesignationCodeClient {
		Object.assign(this, input);
		return this;
	}
}
